import axios from '@/libs/api.request'

export const getPushList = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/push/page'
  })
}

export const addPush = (data) => {
  return axios.request({
    method: 'post',
    data,
    url: '/push'
  })
}


export const editPush = (data) => {
  return axios.request({
    method: 'put',
    data,
    url: '/push'
  })
}

export const changePushStatus = (id,params) => {
  return axios.request({
    method: 'put',
    url: '/push/states/' + id,
    params
  })
}


export const getPushInfo = (id) => {
  return axios.request({
    method: 'get',
    url: '/push/' + id
  })
}

export const delPush = (id) => {
  return axios.request({
    method: 'delete',
    url: '/push/' + id
  })
}